import { EDIT_ROLE, GET_ROLE, GET_ROLE_BY_ID, GET_ROLE_MENU } from '@/api/role/role';

const state = {
    roleMenu: [],
    role: [],
    roleByID: [],
};

const mutations = {
    setRoleMenu: (state, payload) => {
        state.roleMenu = payload;
    },
    setRole: (state, payload) => {
        state.role = payload;
    },
    setRoleByID: (state, payload) => {
        state.roleByID = payload;
    },
};

const actions = {
    getRoleMenu: async ({ commit }, params) => {
        try {
            const resp = await GET_ROLE_MENU(params);
            if (resp.data.httpCode === 200) {
                commit('setRoleMenu', resp.data.data); 
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp && resp.data && resp.data.httpCode === 404) {
                commit('setRoleMenu', []);
            }
            throw err;
        }
    },
    getRole: async ({ commit }, params) => {
        try {
            const resp = await GET_ROLE(params);
            if (resp.data.httpCode === 200) {
                commit('setRole', resp.data.data); 
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp && resp.data && resp.data.httpCode === 404) {
                commit('setRole', []);
            }
            throw err;
        }
    },

    getRoleByID: async ({ commit }, params) => {
        try {
            const resp = await GET_ROLE_BY_ID(params);
            if (resp.data.httpCode === 200) {
                commit('setRoleByID', resp.data.data); 
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp && resp.data && resp.data.httpCode === 404) {
                commit('setRoleByID', []);
            }
            throw err;
        }
    },

    updateRole: async ({ }, args) => {
        return await EDIT_ROLE(args);
    },
};

const getters = {
    roleMenu: (state) => state.roleMenu,
    roleManagement: (state) => state.role,
    roleByID: (state) => state.roleByID
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
